import { useState } from 'react';

import { METRICS } from '../constants';
import { useDraftApplied } from './use-draft-applied';

const makeDefault = () => ({
  year: new Date().getFullYear(),
  regions: [],
  countries: [],
  userTypes: [],
});

// State for the independent month-on-month graph card. The query-driving controls
// (year / region / country / user-type) sit behind Apply, so changing them does
// NOT refire the Redshift query until Apply. The metric is deliberately kept LIVE
// and outside Apply — switching it just re-slices already-fetched rows on the
// client (no query), so gating it would only make it feel broken.
//   * `graphProps` — draft values + handlers + Apply/Reset, spread into <TopSeriesGraphCard>.
//   * `metric` / `appliedYear` — feed the client-side dataset build.
//   * `appliedYear` / `appliedRegions` / `appliedCountries` / `appliedUserTypes` — the query.
export const useGraphControls = () => {
  const { draft, applied, patch, apply, reset, hasUnapplied } = useDraftApplied(
    makeDefault,
  );
  const [metric, setMetric] = useState(METRICS.QL);

  const graphProps = {
    graphYear: draft.year,
    onYearChange: year => patch({ year }),
    graphMetric: metric,
    onMetricChange: setMetric,
    regions: draft.regions,
    onRegionsChange: regions => patch({ regions }),
    countries: draft.countries,
    onCountriesChange: countries => patch({ countries }),
    userTypes: draft.userTypes,
    onUserTypesChange: userTypes => patch({ userTypes }),
    axisYear: applied.year,
    hasUnapplied,
    onApply: apply,
    onReset: reset,
  };

  return {
    graphProps,
    metric,
    appliedYear: applied.year,
    appliedRegions: applied.regions,
    appliedCountries: applied.countries,
    appliedUserTypes: applied.userTypes,
  };
};
